import Header from "../components/header.jsx";
import Sidebar from "../components/sidebar.jsx";
import UnassignedStb from "../components/unassignedstb.jsx";
import Footer from "../components/footer.jsx";

function UnassignedStbpage() {
    return (
        <div>
        <div className='wrapper'>
          <Header />
          <Sidebar /> 
          <UnassignedStb/> 
        </div>
        <Footer /> 
      </div>
      // <Login/>
      );
}
export default UnassignedStbpage;
